// Product card add-to-cart: prevent redirect, update cart count, show toast
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('.fp-card__add-form, .drops-tile__add-form');
  if (!form) return;
  e.preventDefault();
  const r = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
  if (r.ok) {
    const item = await r.json();
    document.dispatchEvent(new CustomEvent('theme:update:cart'));
    showToast(`${item.product_title} added to your basket`);
  }
});

// Product page add-to-cart: intercept before island-product.bundle.js, which only
// dispatches count-update events when cart_type == 'modal' (not our current setting)
document.addEventListener('submit', async (e) => {
  if (!e.target.matches('[data-product-form]')) return;
  e.preventDefault();
  e.stopPropagation();
  const r = await fetch('/cart/add.js', { method: 'POST', body: new FormData(e.target) });
  if (r.ok) {
    const item = await r.json();
    document.dispatchEvent(new CustomEvent('theme:update:cart'));
    showToast(`${item.product_title} added to your basket`);
  }
}, { capture: true });

function showToast(message) {
  document.querySelectorAll('.drops-toast').forEach((t) => t.remove());
  const toast = document.createElement('div');
  toast.className = 'drops-toast';
  toast.textContent = message;
  document.body.appendChild(toast);
  requestAnimationFrame(() => toast.classList.add('drops-toast--visible'));
  setTimeout(() => {
    toast.classList.remove('drops-toast--visible');
    toast.addEventListener('transitionend', () => toast.remove(), { once: true });
  }, 3000);
}

// Mobile header search: the pink search button swaps the header for the search
// form and becomes a close button. Tapping it again (or Escape) restores the nav.
document.addEventListener('click', (e) => {
  const toggle = e.target.closest('#SearchButton');
  if (!toggle) return;
  setMobileSearch(toggle, toggle.getAttribute('aria-expanded') !== 'true');
});

document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  const toggle = document.getElementById('SearchButton');
  if (toggle?.getAttribute('aria-expanded') !== 'true') return;
  setMobileSearch(toggle, false);
  toggle.focus();
});

function setMobileSearch(toggle, open) {
  const header = toggle.closest('.site-header');
  const input = header.querySelector('.drops-search-input');
  // Blur before fading out so the keyboard drops with the fade, not after it
  if (!open) input?.blur();
  header.classList.toggle('drops-search-open', open);
  toggle.setAttribute('aria-expanded', open);
  // preventScroll stops iOS scrolling the page to "reveal" the input while the keyboard opens
  if (open) input?.focus({ preventScroll: true });
}
